













































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import appconst from '@/lib/appconst';
import storeaddressInfo from '@/store/entities/back-storeaddress-list';
import Enums from '@/lib/enums'

// 表单数据模型（对应后端CreatePrePlanDto）
interface FormData {
    id: number; // 批次ID（新增时为0/undefined，编辑时为具体ID）
    inStockNumbersText: string; // 文本域绑定值（一行一个入库单号）
    inStockNumbers: string[]; // 传递给后端的入库单号数组
    remark: string; // 备注
    isSelf: boolean; // 是否自装箱
    userId: number; // 用户ID（根据项目需求获取，如从Vuex/当前登录用户获取）
}

@Component({ name: 'PrePlanForm' })
export default class PrePlanForm extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    // 表单数据
    formData: FormData = {
        id: 0,
        inStockNumbersText: '',
        inStockNumbers: [],
        remark: '',
        isSelf: false,
        userId: 0 // 实际项目中替换为当前登录用户ID，如 this.$store.state.user.id
    };
    // 表单校验规则
    formRules = {
        inStockNumbersText: [
            { required: true, message: '请输入入库单号', trigger: 'blur' },
            { validator: this.validateInStockNumbers, trigger: 'blur' }
        ],
        isSelf: [
            { required: true, message: '请选择是否自装箱', trigger: 'change' }
        ]
    };

    // 监听弹窗显隐，初始化表单
    visibleChange(val: boolean) {
        if (val) {
            this.initForm();
        } else {
            this.resetForm();
        }
    }

    // 初始化表单（编辑时加载Vuex中的模型数据）
    async initForm() {
        // 获取Vuex中存储的模型（编辑时为详情数据，新增时为{id:0}）
        const prePlanModel = this.$store.state.frontpreplan.stockmodel;
        if (prePlanModel && prePlanModel.id) {
            // 编辑状态：赋值ID、备注、是否自装箱，拆分入库单号为文本域字符串（一行一个）
            this.formData.id = prePlanModel.id;
            this.formData.remark = prePlanModel.remark || '';
            this.formData.isSelf = prePlanModel.isSelf || false;
            // 若后端返回了入库单号数组，转换为文本域格式（一行一个）
            if (prePlanModel.planWarehouseStocks && prePlanModel.planWarehouseStocks.length) {
                const inStockNumbers = prePlanModel.planWarehouseStocks.map(item => item.inStockNumber || '');
                this.formData.inStockNumbersText = inStockNumbers.filter(Boolean).join('\n');
            }
        } else {
            // 新增状态：重置表单
            this.resetForm();
        }
    }

    // 重置表单
    resetForm() {
        this.formData = {
            id: 0,
            inStockNumbersText: '',
            inStockNumbers: [],
            remark: '',
            isSelf: false,
            userId: 0
        };
        // 清空表单校验状态
        (this.$refs.prePlanForm as any).resetValidation();
    }

    // 校验入库单号（非空、去重）
    validateInStockNumbers(rule: any, value: string, callback: Function) {
        if (!value || value.trim() === '') {
            callback(new Error('入库单号不能为空'));
            return;
        }
        // 拆分入库单号（按换行拆分，去空、去重）
        const inStockNumbers = value.split('\n').map(item => item.trim()).filter(Boolean);
        if (inStockNumbers.length === 0) {
            callback(new Error('请输入有效的入库单号'));
            return;
        }
        callback();
    }

    // 子组件 PrePlanForm 的 handleSubmit 方法
    async handleSubmit() {
        try {
            // 表单校验
            const formRef = this.$refs.prePlanForm as any;
            await formRef.validate();

            // 处理入库单号：文本域转数组（一行一个，去空、去重）
            this.formData.inStockNumbers = this.formData.inStockNumbersText
                .split('\n')
                .map(item => item.trim())
                .filter(Boolean)
                .filter((value, index, self) => self.indexOf(value) === index); // 去重

            // 构造提交参数（对应后端CreatePrePlanDto）
            const submitData = {
                inStockNumbers: this.formData.inStockNumbers,
                remark: this.formData.remark,
                userId: this.formData.userId,
                isSelf: this.formData.isSelf,
                id: this.formData.id // 关键：新增时id=0/undefined，编辑时为具体批次ID
            };

            // 调用Vuex中的create API（复用同一接口，通过id区分新增/编辑）
            await this.$store.dispatch({
                type: 'frontpreplan/create',
                data: submitData
            });
            // 提交成功
            this.$Message.success(this.formData.id ? '修改成功！' : '创建成功！');
            // 不直接修改 this.value，通过 $emit 通知父组件
            this.$emit('input', false);
            this.$emit('save-success'); // 通知列表页面刷新
        } catch (error) {
            this.$Message.error(this.formData.id ? '修改失败！' : '创建失败！');
        }
    }

    // 子组件 PrePlanForm 的 handleCancel 方法
    handleCancel() {
        // 不直接修改 this.value，通过 $emit 通知父组件更新 modalShow
        this.$emit('input', false);
        this.resetForm();
    }

    // 组件销毁前重置表单
    beforeDestroy() {
        this.resetForm();
    }
}
